import * as React from "react";

const SvgIconSelectDown = (props) => {
  return (
    <svg width={12.177} height={7.306} viewBox="0 0 3.222 1.933" {...props}>
      <g fill="none" stroke="#c1cacc" strokeLinecap="round" strokeWidth={0.644}>
        <path d="M2.899.33L1.61 1.619M.322.33l1.289 1.289" />
      </g>
    </svg>
  );
};

export default SvgIconSelectDown;
